var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card" },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("coda-result")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.coda-split"),
                  expression: "$ct('tooltip.coda-split')",
                },
              ],
              staticClass: "mr",
              attrs: { white: "", disabled: _vm.selectedItems.length != 1 },
              on: {
                click: function ($event) {
                  _vm.splitRows = true
                },
              },
            },
            [_c("w-fa", { attrs: { icon: ["fas", "columns"] } })],
            1
          ),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.coda-edit"),
                  expression: "$ct('tooltip.coda-edit')",
                },
              ],
              staticClass: "ml mr",
              attrs: { white: "", disabled: _vm.selectedItems.length != 1 },
              on: {
                click: function ($event) {
                  return _vm.edit()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "pen" } })],
            1
          ),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.coda-remove"),
                  expression: "$ct('tooltip.coda-remove')",
                },
              ],
              staticClass: "ml mr",
              attrs: { white: "", disabled: _vm.selectedItems.length == 0 },
              on: {
                click: function ($event) {
                  return _vm.remove()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "minus" } })],
            1
          ),
          _vm.uploading
            ? _c("w-progress-linear", {
                staticClass: "full inTitle",
                attrs: { color: "#1c86f0" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("w-data-table", {
        staticClass: "grow coda-preview",
        style: { width: "100%" },
        attrs: {
          compare: _vm.compare,
          items: _vm.items,
          "selected-items": _vm.selectedItems,
          columns: _vm.columns,
        },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.uploading, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.uploading, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
      false
        ? _c(
            "w-modal",
            [
              _c("app-coda-split-rows", {
                on: {
                  cancel: function ($event) {
                    _vm.splitRows = false
                  },
                  confirm: function ($event) {
                    return _vm.split($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.splitRows,
            callback: function ($$v) {
              _vm.splitRows = $$v
            },
            expression: "splitRows",
          },
        },
        [
          _c("app-coda-split-modal", {
            attrs: { bank: _vm.firstSelectedBank },
            on: {
              cancel: function ($event) {
                _vm.splitRows = false
              },
              confirm: function ($event) {
                return _vm.splitRecords($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.toEditBank != null },
          on: {
            input: function ($event) {
              return _vm.cancelEdit()
            },
          },
        },
        [
          _vm.toEditBank
            ? _c(
                "w-card",
                { staticClass: "card", attrs: { "max-width": "750" } },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("coda-bank-edit"))),
                  ]),
                  _c(
                    "w-scroll-view",
                    { staticClass: "grow", attrs: { tag: "w-card-content" } },
                    [
                      _c("app-bank-edit-default", {
                        attrs: {
                          bank: _vm.toEditBank,
                          multiple: false,
                          "lock-bank-movement": "",
                          "hide-title": "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelEdit()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.applyEdit()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.Apply")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }